<div class="m2 pl2">
  <h1>Flags</h1>
  <mat-selection-list class="col-10 mx-auto" (selectionChange)="change($event)">
    @for (flag of flags; track flag) {
      <mat-list-option [selected]="flag.get()" [value]="flag.name">
        <b>{{ flag.title }}</b><br /><small>{{ flag.description }}</small>
      </mat-list-option>
    }
  </mat-selection-list>
</div>
